import type { SolutionListItem } from '@loop3/universe'
import { useQuery } from '@tanstack/react-query'
import { getPersonSolutionIds } from '@/lib/api/kb'
import { isUuid } from '@/lib/compute/universe'
import { useSolutionsLibrary } from './useSolutionsLibrary'

const EMPTY_IDS: string[] = []
const EMPTY_ITEMS: SolutionListItem[] = []

/** Live kb solutions a person worked on, in library order; empty for non-teammates. */
export function usePersonSolutions(personsId: string | undefined) {
  const ids = useQuery({
    queryKey: ['kb', 'person-solutions', personsId],
    queryFn: () => getPersonSolutionIds(personsId!),
    enabled: !!personsId && isUuid(personsId),
    // The copy refreshes hourly; 5 min keeps back-navigation instant.
    staleTime: 5 * 60_000,
  })
  const wanted = ids.data ?? EMPTY_IDS
  const library = useSolutionsLibrary({ enabled: wanted.length > 0 })
  return (library.data ?? EMPTY_ITEMS).filter((s) => wanted.includes(s.id))
}
